import React, { useEffect, useState } from 'react';

import { IConsultantArticleTile } from 'components/static/ConsultantArticleTile';

import { EUrlSearchParam } from 'types/enums/EUrlSearchParam';

import createConsultantArticleTiles from 'utils/createConsultantArticleTiles';

import { ERoute } from '../types/enums/ERoute';
import currentLanguage from './sulu/currentLanguage';
import getAllConsultantArticles from './sulu/getAllConsultantArticles';

interface SuitableArticlesProps {
  headlineSuitableConsultantsArticles: string;
  suitableConsultantsArticles: string;
}

const SuitableArticles: React.FC<SuitableArticlesProps> = ({
  headlineSuitableConsultantsArticles,
  suitableConsultantsArticles,
}) => {
  const [suitableArticlesTiles, setSuitableArticlesTiles] = useState<
    IConsultantArticleTile[]
  >([]);

  useEffect(() => {
    if (suitableConsultantsArticles) {
      const urls = suitableConsultantsArticles
        .split(',')
        .filter(url => url.trim() !== ''); // Filter out empty strings

      // Create a set to track added article IDs (to avoid duplicates)
      const addedArticleIds = new Set<string>();

      urls.forEach(urlString => {
        const url = new URL(urlString.trim());
        const consultantId =
          url.searchParams.get(EUrlSearchParam.CONSULTANT_ID) ?? '';
        const articleId =
          url.searchParams.get(EUrlSearchParam.ARTICLE_ID) ?? '';

        getAllConsultantArticles(parseInt(consultantId, 10)).then(
          (articles: any[]) => {
            // Filter articles that match the extracted articleId
            const filteredArticles = articles.filter(
              article => article.id === articleId,
            );

            const suitableTiles = filteredArticles
              .filter(article => !addedArticleIds.has(article.id)) // Avoid duplicates
              .map(article => {
                addedArticleIds.add(article.id); // Mark article as added
                return {
                  id: article.id || '',
                  title: article.title || '',
                  description: article.description || 'Keine Beschreibung',
                  imageUrl: article.photo || '',
                  contentType: article.category,
                  url: `/${currentLanguage}/${ERoute.CONSULTANT_ARTICLE}?${EUrlSearchParam.CONSULTANT_ID}=${consultantId}&${EUrlSearchParam.ARTICLE_ID}=${articleId}`,
                };
              });

            // Add the new tiles to the existing tiles
            setSuitableArticlesTiles(prevTiles => [
              ...prevTiles,
              ...suitableTiles,
            ]);
          },
        );
      });
    }
  }, [suitableConsultantsArticles]);

  return (
    <div>
      {suitableArticlesTiles.length > 0 && (
        <div className='mt-6'>
          <h3>{headlineSuitableConsultantsArticles}</h3>
          <div className='flex items-center justify-center flex-wrap gap-5 mt-5'>
            {createConsultantArticleTiles(false, suitableArticlesTiles)}
          </div>
        </div>
      )}
    </div>
  );
};

export default SuitableArticles;
